export default __webpack_public_path__ + "static/media/bank-visa.7d51cf93.svg";